import {
  ApproveParamsTypes,
  CopyTimeKeepingParamsTypes,
  CreatePayrollPeriodsParams,
  ImportRequestType,
  ImportResponseType,
  KTApproveParamsTypes,
  KTUpdateParamsTypes,
  PayrollApproveListDataTypes,
  PayrollPeriodsDataTypes,
  StaffJoinedProjectDataTypes,
  UpdatePayrollPeriodsParams
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllPayrollPeriodsService = async (
  params?: BaseFilterParams & {
    _projectId?: string,
    _staffFullTimeId?: string,
    _getCodeDetail?: boolean
  },
): Promise<APIPaginationResponse<PayrollPeriodsDataTypes[]>> => {
  const res = await axiosInstance.get('payroll-periods', { params });
  return res.data;
};

export const getPayrollPeriodsByIdService = async (
  id: string,
): Promise<PayrollPeriodsDataTypes> => {
  const res = await axiosInstance.get(`payroll-periods/${id}`);
  return res.data.data;
};

export const updatePayrollPeriodsByIdService = async (
  id: string,
  params: UpdatePayrollPeriodsParams
): Promise<PayrollPeriodsDataTypes> => {
  const res = await axiosInstance.put(`payroll-periods/${id}`, params);
  return res.data.data;
};

export const createPayrollPeriodsService = async (
  params: CreatePayrollPeriodsParams,
): Promise<void> => {
  await axiosInstance.post('payroll-periods', params);
};

export const deletePayrollPeriodsService = async (params: { ids: number[] })
  : Promise<void> => {
  const res = await axiosInstance.delete('payroll-periods', { data: params });
  return res.data;
};

export const getPayrollApproveListService = async (
  params?: BaseFilterParams & {
    _exceptPayrollPeriodStatusApprove?: string,
    _projectId: string,
    _staffFullTimeId: string
  },
): Promise<APIPaginationResponse<PayrollApproveListDataTypes[]>> => {
  const res = await axiosInstance.get('payroll-periods/approve-list', { params });
  return res.data;
};

export const supApproveSalaryByIdService = async (
  id: string,
): Promise<void> => {
  const res = await axiosInstance.put(`payroll-periods/${id}/approve`);
  return res.data;
};

export const acApproveSalaryByIdService = async (
  id: string,
  params: ApproveParamsTypes
): Promise<void> => {
  const res = await axiosInstance.put(`payroll-periods/${id}/ac-approve`, params);
  return res.data;
};

export const opApproveSalaryByIdService = async (
  id: string,
  params: ApproveParamsTypes
): Promise<void> => {
  const res = await axiosInstance.put(`payroll-periods/${id}/op-approve`, params);
  return res.data;
};

export const ktApproveSalaryByIdService = async (
  id: string,
  params: KTApproveParamsTypes
): Promise<void> => {
  const res = await axiosInstance.put(`payroll-periods/${id}/kt-approve`, params);
  return res.data;
};

export const getApproveStatusCountService = async ():
  Promise<{ processing: number }> => {
  const res = await axiosInstance.get('payroll-periods/approve-status-count');
  return res.data.data;
};

export const exportSalaryReportService = async (
  projectId: string,
  payrollPeriodId: string
): Promise<{ link: string }> => {
  const res = await axiosInstance.post(`projects/${projectId}/payroll-periods/${payrollPeriodId}/export-for-import`);
  return res.data.data;
};

export const importSalaryReportService = async (
  params: ImportRequestType & { payrollPeriodId: string, projectId: string },
): Promise<ImportResponseType> => {
  const bodyForm = new FormData();
  bodyForm.append('file', params.file);
  bodyForm.append('preview', params.preview ? '1' : '0');
  const res = await axiosInstance.post(`projects/${params.projectId}/payroll-periods/${params.payrollPeriodId}/import`, bodyForm, {
    params: {
      payrollPeriodId: params.payrollPeriodId,
      projectId: params.projectId
    }
  });
  return res.data.data;
};

export const ktUpdateSalaryByIdService = async (
  id: string,
  params: KTUpdateParamsTypes
): Promise<void> => {
  const res = await axiosInstance.put(`payroll-periods/${id}/update-transfer`, params);
  return res.data;
};

export const getAllStaffJoinedProjectService = async (
  monthPayroll: string,
  staffId: number,
): Promise<StaffJoinedProjectDataTypes[]> => {
  const res = await axiosInstance.get(`payroll-periods/${monthPayroll}/staff-join-in-payroll`, {
    params: {
      staffId
    }
  });
  return res.data.data;
};

export const copyTimeKeeping = async (params: CopyTimeKeepingParamsTypes): Promise<void> => {
  const res = await axiosInstance.post(`payroll-periods/${params.idPayroll}/copy`, {
    name: params.name,
    startDate: params.startDate,
    endDate: params.endDate,
  });
  return res.data;
};

export const reopenPayrollPeriodService = async (id: string): Promise<void> => {
  const res = await axiosInstance.post(`payroll-periods/${id}/reopen`);
  return res.data;
};
